import { render, staticRenderFns } from "./PanelWidgets.vue?vue&type=template&id=66a4ddd6&scoped=true&"
import script from "./PanelWidgets.vue?vue&type=script&lang=ts&"
export * from "./PanelWidgets.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWidgets.vue?vue&type=style&index=0&id=66a4ddd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a4ddd6",
  null
  
)

export default component.exports